import client, { IMG_URL } from "./client";

export const uploadImage = (file) => {
  const formData = new FormData();
  formData.append("image", file);
  return client.post(`${IMG_URL}/v1/upload`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
